import React from 'react';
import { Col, Row } from '../../grid';
import { Span } from '../../typography';
import TimesSelect from './TimesSelect';

export default ({
  value,
  onChoose,
  error,
  getTimeFee,
  choices,
  disabled,
}) => (
  <Row>
    <Col xs={12} paddingTop="0px">
      <TimesSelect
        value={value}
        onChange={({ target: { value } }) => onChoose(value)}
        error={error}
        disabled={disabled}
      >
        {choices.map(
          value => <option value={value} key={value}>{getTimeFee(value)}</option>,
        )}
      </TimesSelect>
      <Span fontSize="12px">
        Levering samme dag kræver telefonisk aftale efter bestilling.
        Vi ringer dig op når vi har fået din ordre og aftaler nærmere.
      </Span>
    </Col>
  </Row>
);
